import { useReveal } from "../lib/useReveal";
import { Heart, MessageCircle, BookOpen, Users, ArrowRight, Sparkles, MapPin } from "lucide-react";

// Genesis Recovery's 4 core features + 2 extensions — styled exactly like soberfriend.io's feature grid
const FEATURES = [
    {
        Icon: Heart,
        iconBg: "bg-emerald-100",
        iconColor: "text-emerald-600",
        title: "Daily Check-Ins",
        body: "Track your mood, cravings, and daily commitment in a safe, judgment-free space.",
        cta: "See how it works",
        href: "#how-it-works",
    },
    {
        Icon: MessageCircle,
        iconBg: "bg-blue-100",
        iconColor: "text-blue-600",
        title: "AI Companion (Hope)",
        body: "Talk to a supportive AI companion whenever you feel alone or overwhelmed.",
        cta: "Meet Hope",
        href: "#hope",
    },
    {
        Icon: BookOpen,
        iconBg: "bg-purple-100",
        iconColor: "text-purple-600",
        title: "Private Journaling",
        body: "Write freely and securely. Your thoughts stay completely private.",
        cta: "Explore journaling",
        href: "#journal",
    },
    {
        Icon: Users,
        iconBg: "bg-amber-100",
        iconColor: "text-amber-600",
        title: "Mentor Support",
        body: "Connect with mentors who understand your recovery journey.",
        cta: "Find a mentor",
        href: "#mentors",
    },
    {
        Icon: Sparkles,
        iconBg: "bg-rose-100",
        iconColor: "text-rose-600",
        title: "Progress & Milestones",
        body: "Celebrate 30, 60, 90 days and beyond. Visible only to you — no shame, just progress.",
        cta: "Track progress",
        href: "#progress",
    },
    {
        Icon: MapPin,
        iconBg: "bg-cyan-100",
        iconColor: "text-cyan-600",
        title: "Treatment Directory",
        body: "Verified sober living, rehabs, outpatient programs, and community resources — nationwide.",
        cta: "Browse directory",
        href: "/directory",
    },
];

export default function Features() {
    const ref = useReveal();
    return (
        <section
            id="features"
            ref={ref}
            data-testid="features-section"
            className="py-20 md:py-24 bg-background scroll-mt-20"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16 reveal">
                    <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-5 tracking-tight">
                        Support for recovery — without pressure
                    </h2>
                    <p className="text-lg text-muted-foreground">
                        Tools designed to support your journey, not control it. Everything you need to
                        stay accountable, reflect honestly, and connect with support — at your own pace.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 reveal">
                    {FEATURES.map((f, i) => (
                        <a
                            key={f.title}
                            href={f.href}
                            data-testid={`feature-card-${i}`}
                            className="group bg-card border rounded-2xl p-8 hover:shadow-lg hover:border-primary/40 hover:-translate-y-0.5 transition-all flex flex-col"
                        >
                            <div
                                className={`w-12 h-12 ${f.iconBg} rounded-xl flex items-center justify-center mb-5`}
                            >
                                <f.Icon className={`w-6 h-6 ${f.iconColor}`} />
                            </div>
                            <h3 className="text-xl font-bold text-foreground mb-3">{f.title}</h3>
                            <p className="text-muted-foreground leading-relaxed flex-1">{f.body}</p>
                            {/* <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary group-hover:gap-2.5 transition-all">
                                {f.cta}
                                <ArrowRight className="w-3.5 h-3.5" />
                            </div> */}
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
